export default __webpack_public_path__ + "28f1c1347d3c7650faf5d7ca6b2a3f16.ttf";